import type { DecodedShipmentTrack } from '@/utils/shipment-detail-map-decode';
import { normalizeTrackPointFacts } from './normalize-track-point-facts';
import type { DeviceTrackPoints } from './types';

/** Map decoded shipment track rows into graph inputs (one shipment). */
export function deviceTracksFromDecodedRows(
  rows: readonly {
    device_id: number;
    decoded: DecodedShipmentTrack | null;
  }[],
): DeviceTrackPoints[] {
  const out: DeviceTrackPoints[] = [];
  for (const row of rows) {
    if (!row.decoded?.points?.length) continue;
    out.push({
      deviceId: row.device_id,
      points: row.decoded.points.map((p) => {
        const facts = normalizeTrackPointFacts(p);
        return {
          lat: p.location[1],
          lng: p.location[0],
          timestampSec: p.timestampSec,
          battery: facts.battery,
          fixTypeCode: facts.fixTypeCode,
          accuracyMeters: facts.accuracyMeters,
        };
      }),
    });
  }
  return out;
}
